import { handleActions, createActions } from 'redux-actions';
import { Map } from 'immutable';

export const { setEnterprise, updateEnterprise, updateEnterpriseConfig } = createActions({
  setEnterprise: result => {
    return result;
  },
  updateEnterprise: result => {
    return result;
  },
  updateEnterpriseConfig: result => {
    return result;
  }
});

const initState = Map({
  enterprise: {},
  enterpriseConfig: {}
});

const enterprise = handleActions(
  {
    [setEnterprise]: (state, action) => {
      return state.set('enterprise', action.payload);
    },
    [updateEnterprise]: (state, action) => {
      return state.update('enterprise', val => {
        return { ...val, ...action.payload };
      });
    },
    [updateEnterpriseConfig]: (state, action) => {
      return state.update('enterpriseConfig', val => {
        return { ...val, ...action.payload };
      });
    }
  },
  initState
);

export default enterprise;
